/**
 * Ficha de demonstração do paciente.
 *
 * Uma ficha completa (Clara Ribeiro) e o mínimo para os demais: é assim que uma
 * base real chega — um cadastro caprichado e vários pela metade. A ficha que
 * abre com metade dos campos vazios é o caso normal, não a exceção, e a tela
 * precisa ser desenhada para ele.
 */

import { PACIENTES } from './contatosDemo';
import type { EventoDoPaciente, FichaDoPaciente, ResumoFinanceiroDoPaciente } from './tipos';

function fichaVazia(id: string, nome: string, telefone: string, nascimento: string, convenioId: string, profissional: string): FichaDoPaciente {
    return {
        id, nome, nomeSocial: '', nascimento, sexo: 'nao-informado', cpf: '', rg: '', estadoCivil: '', profissao: '',
        telefone, telefoneSecundario: '', email: '', notificacoes: 'whatsapp', contatoEmergencia: '',
        cep: '', rua: '', numero: '', complemento: '', bairro: '', cidade: '', estado: '',
        profissional, convenioId, alergias: '', observacoes: '', origem: '', indicadoPor: '',
        cadastradoEm: '2025-01-01', atualizadoEm: '2026-09-02T10:00:00-03:00', atualizadoPor: 'Recepção',
    };
}

export const FICHAS: Record<string, FichaDoPaciente> = {
    'p-clara': {
        id: 'p-clara', nome: 'Clara Ribeiro', nomeSocial: '', nascimento: '1992-03-12', sexo: 'feminino',
        cpf: '315.772.070-00', rg: '38.442.109-7', estadoCivil: 'casada', profissao: 'Arquiteta',
        telefone: '(11) 99999-9999', telefoneSecundario: '', email: 'clara.ribeiro@example.com',
        notificacoes: 'whatsapp', contatoEmergencia: 'Marcos Ribeiro · (11) 98812-4410',
        cep: '01452-000', rua: 'Rua Pedroso Alvarenga', numero: '1245', complemento: 'Apto 142',
        bairro: 'Jardim Paulistano', cidade: 'São Paulo', estado: 'SP',
        profissional: 'Dra. Ana Prado', convenioId: 'unimed',
        alergias: 'Sensibilidade a ácido glicólico. Vermelhidão prolongada após peeling.',
        observacoes: 'Prefere atendimento no fim da tarde. Trabalha próximo à clínica.',
        origem: 'indicacao', indicadoPor: 'Helena Vasques',
        cadastradoEm: '2024-07-12', atualizadoEm: '2026-09-02T16:20:00-03:00', atualizadoPor: 'Recepção',
    },
    ...Object.fromEntries(
        PACIENTES.filter((p) => p.id !== 'p-clara').map((p) => [
            p.id,
            fichaVazia(p.id, p.nome, p.telefone, p.nascimento, p.convenioId ?? '', p.profissional),
        ]),
    ),
};

export const FINANCEIRO: Record<string, ResumoFinanceiroDoPaciente> = {
    'p-clara': {
        totalInvestidoCentavos: 2190000,
        emAbertoCentavos: 435000,
        vencidoCentavos: 0,
        ticketMedioCentavos: 128400,
        pacote: { nome: 'Pacote 10 sessões', sessoesConcluidas: 4, sessoesTotais: 10 },
    },
};

export const LINHA_DO_TEMPO: Record<string, EventoDoPaciente[]> = {
    'p-clara': [
        {
            id: 'e1', titulo: 'Parcela recebida', quandoEm: '2026-09-02T14:10:00-03:00', icone: 'circle-dollar-sign', tom: 'success',
            detalhes: [
                { rotulo: 'Valor', valor: 'R$ 1.500,00' },
                { rotulo: 'Forma de pagamento', valor: 'Boleto' },
                { rotulo: 'Conta', valor: 'Banco padrão' },
            ],
        },
        { id: 'e2', titulo: 'Agendamento concluído', quandoEm: '2026-09-02T11:00:00-03:00', icone: 'calendar-check', tom: 'brand', autor: 'Dra. Ana Prado', descricao: 'Limpeza de pele — Sala 2.' },
        { id: 'e3', titulo: 'Documento assinado', quandoEm: '2026-09-01T17:42:00-03:00', icone: 'file-check', tom: 'success', descricao: 'Termo de consentimento — Botox.' },
        { id: 'e4', titulo: 'Título criado', quandoEm: '2026-09-01T09:15:00-03:00', icone: 'receipt', detalhes: [{ rotulo: 'Valor', valor: 'R$ 1.800,00' }] },
        { id: 'e5', titulo: 'Lembrete enviado pela Fórmula MED', quandoEm: '2026-08-31T18:00:00-03:00', icone: 'sparkles', tom: 'brand', descricao: 'WhatsApp — confirmação de consulta.' },
        { id: 'e6', titulo: 'Paciente cadastrada', quandoEm: '2024-07-12T10:00:00-03:00', icone: 'user-plus', autor: 'Recepção' },
    ],
};

export const FINANCEIRO_VAZIO: ResumoFinanceiroDoPaciente = {
    totalInvestidoCentavos: 0, emAbertoCentavos: 0, vencidoCentavos: 0, ticketMedioCentavos: 0,
};
